import { render, staticRenderFns } from "./shapinggolf.vue?vue&type=template&id=4ad59e5e&scoped=true"
import script from "./shapinggolf.vue?vue&type=script&lang=js"
export * from "./shapinggolf.vue?vue&type=script&lang=js"
import style0 from "./shapinggolf.vue?vue&type=style&index=0&id=4ad59e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad59e5e",
  null
  
)

export default component.exports